import { render, staticRenderFns } from "./marketing-staffs.vue?vue&type=template&id=2dc24b59&"
import script from "./marketing-staffs.vue?vue&type=script&lang=js&"
export * from "./marketing-staffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports